// extracted by mini-css-extract-plugin
export default {"row":"editLeaderboard_row__Tg9cG","col":"editLeaderboard_col__1It8z","card":"editLeaderboard_card__H-lE7"};